import {useCompanyQuery} from "@/api/companyApi";
import InstagramCampaignIcon from "@/assets/colorable/instagram_campaign.svg?react";
import TiktokCampaignIcon from "@/assets/colorable/tiktok_campaign.svg?react";
import UgcCampaignIcon from "@/assets/colorable/ugc_campaign.svg?react";
import InstagramCampaignDarkGradientIcon from "@/assets/dark_gradient/instagram_campaign.svg?react";
import TiktokCampaignDarkGradientIcon from "@/assets/dark_gradient/tiktok_campaign.svg?react";
import InstagramCampaignLightGradientIcon from "@/assets/light_gradient/instagram_campaign.svg?react";
import InstagramCampaignDefaultIcon from "@/assets/light_gradient/instagram_campaign_default.svg?react";
import TiktokCampaignLightGradientIcon from "@/assets/light_gradient/tiktok_campaign.svg?react";
import TiktokCampaignDefaultIcon from "@/assets/light_gradient/tiktok_campaign_default.svg?react";
import UgcCampaignDefaultIcon from "@/assets/light_gradient/ugc_campaign_default.svg?react";
import CampaignTile from "@/components/Campaign/management/CampaignTile";
import Modal from "@/components/Common/Modal";
import {useIsAdmin, useIsInfuencer, useSelectedCompanyId} from "@/hooks/useUserHooks";
import {useMiscActions} from "@/store/campaignForm";
import {createCampaignForCompanyAtom} from "@/store/jotaiAtoms";
import useUserStore from "@/store/user";
import {useAtom} from "jotai";
import {useMemo, type FC} from "react";
import {useTranslation} from "react-i18next";
import {useEffectOnce} from "react-use";

const CreateCampaignModal: FC = () => {
  const {t} = useTranslation();
  const actions = useMiscActions();
  const isAdmin = useIsAdmin();
  const isInfluencer = useIsInfuencer();
  const userPlan = useUserStore(state => state.user.package_subscription);
  const selectedCompanyId = useSelectedCompanyId();
  const [companyForCampaignCreation, setCreateCampaignForCompany] = useAtom(createCampaignForCompanyAtom);
  const {data: company} = useCompanyQuery({
    companyId: companyForCampaignCreation!,
    queryOptions: {
      enabled:
        isAdmin && !!companyForCampaignCreation && (companyForCampaignCreation !== selectedCompanyId || isInfluencer),
    },
  });
  const plan = useMemo(() => (!!company ? company.package_subscription : userPlan), [company, userPlan]);

  useEffectOnce(() => {
    actions.resetStore();
  });

  return (
    <Modal
      backgroundClassName="max-w-110"
      onClose={() => setCreateCampaignForCompany(null)}
      modalTitle={t("chooseCampaignStyle")}
      customBottomRow={<></>}
      className={"flex flex-col gap-2.5"}>
      <CampaignTile
        campaignType="instagram"
        DarkIcon={InstagramCampaignDarkGradientIcon}
        DefaultIcon={InstagramCampaignDefaultIcon}
        description="instagramCampaignDescription"
        hasSubscription={plan?.instagram_campaigns}
        Icon={InstagramCampaignIcon}
        LightIcon={InstagramCampaignLightGradientIcon}
        title="instagramCampaign"
      />
      <CampaignTile
        campaignType="tiktok"
        DarkIcon={TiktokCampaignDarkGradientIcon}
        DefaultIcon={TiktokCampaignDefaultIcon}
        description="tiktokCampaignDescription"
        hasSubscription={plan?.tiktok_campaigns}
        Icon={TiktokCampaignIcon}
        LightIcon={TiktokCampaignLightGradientIcon}
        title="tiktokCampaign"
      />
      <CampaignTile
        campaignType="ugc"
        description="ugcCampaignDescription"
        DefaultIcon={UgcCampaignDefaultIcon}
        hasSubscription
        Icon={UgcCampaignIcon}
        title="ugcCampaign"
      />
    </Modal>
  );
};

export default CreateCampaignModal;
